import map from "lodash/fp/map";
import constants from "../../core/constants";

import moment from "moment";

class CaptainFinancePageTransform {
  constructor() {
    "ngInject";

    this.fields = [
      { name: "captain", title: "Captain Name", isSortable: true },
      { name: "name", title: "Invoice Name", isSortable: true },
      { name: "basic_plan", title: "Basic Plan" },
      { name: "backup_plan", title: "Backup Plan" },
      { name: "deduction_plan", title: "Supply Deduction Plan" },
      { name: "invoiceData", title: "Invoice" },
      { name: "status", title: "Status" },
    ];
  }

  justify(data) {
    const formatDate = (date) => moment(date).format(constants.dateFormat);
    const format = (item) => {
      item.invoiceData = item.invoice
        ? formatDate(item.invoice.start_date)
        : "No Open Invoice";
      item.hasInvoice = Boolean(item.invoice);
      item.captainId = item.captain._id;

      return item;
    };
    return map(format)(data);
  }
}

export default CaptainFinancePageTransform;



// WEBPACK FOOTER //
// ./src/pages/captainFinance/captainFinance.transforms.js